/* eslint-disable @typescript-eslint/no-explicit-any */
import { ProductVariant } from '@api-client/src/types';

type EnhancedProduct = ProductVariant;

const enhanceProduct = (productResponse: any) => {
  if (!productResponse || Object.keys(productResponse).length === 0) return;

  let products = [];
  if (Array.isArray(productResponse)) {
    products = productResponse.filter((item) => Object.keys(item).length !== 0);
  }

  const getVariantId = (product: any) => {
    if (product?.variantBySelectedOptions?.id) {
      return product.variantBySelectedOptions.id;
    }

    if (Array.isArray(product.variants) && product.variants.length > 0) {
      return product.variants[0].id;
    }

    return '';
  };

  const enhancedProductResponse: EnhancedProduct[] = products.map(
    (product) =>
      ({
        ...product,
        name:
          product.variantBySelectedOptions && product.variantBySelectedOptions !== null
            ? `${product.title} - ${product.variantBySelectedOptions.title}`
            : product.title,
        images: product?.images,
        media: product?.media,
        price: {
          original:
            product.variantBySelectedOptions && product.variantBySelectedOptions !== null
              ? product.variantBySelectedOptions?.compareAtPriceV2?.amount
              : product.variants
              ? product.variants[0].compareAtPriceV2?.amount
              : 0,
          current:
            product.variantBySelectedOptions && product.variantBySelectedOptions !== null
              ? product.variantBySelectedOptions?.priceV2?.amount
              : product.variants
              ? product.variants[0].priceV2?.amount
              : 0,
        },
        available:
          product.variantBySelectedOptions && product.variantBySelectedOptions !== null
            ? product.variantBySelectedOptions?.quantityAvailable
            : product.variants
            ? product.variants[0].availableForSale
            : true,
        productType: product.productType,
        options: product.options,
        _id: product.id,
        variantId: getVariantId(product),
        _description: product.description,
        _descriptionHtml: product.descriptionHtml,
        _categoriesRef: [],
        _slug: product.handle,
        _coverImage: product?.images[0],
        _mainPrice: product.variants ? product.variants[0].priceV2?.amount : 0,
      } as EnhancedProduct),
  );
  return enhancedProductResponse;
};

export default enhanceProduct;
